/**
 * NFC Is Club Key
 */

export default {
  isClub: 'nfc_is_club'
};
